import inputMask from "./InputMask";

export default inputMask;
